export default {
  namespaced: true,
  state: {
    companyHandle: [],
    // mqtt
    orderInfo: []
  },
  mutations: {
    // 处理添加
    set_company_handle (state, handle) {
      let flag = false
      let alarm = state.companyHandle
      for (let i = 0; i < alarm.length; i++) {
        if (parseInt(handle.id) === parseInt(alarm[i].id)) {
          alarm[i] = handle
          flag = true
        }
      }
      if (!flag) {
        alarm.unshift(handle)
        state.companyHandle = alarm
      }
    },
    //  移除
    set_del_companyHandle (state, alarmId) {
      for (let i = 0; i < state.companyHandle.length; i++) {
        if (parseInt(alarmId) === parseInt(state.companyHandle[i].id)) {
          state.companyHandle.remove(state.companyHandle[i])
        }
      }
    },
    // mqtt订单报警
    set_order_info (state, info) {
      let flag = false
      for (let i = 0; i < state.orderInfo.length; i++) {
        if (parseInt(info.alarmid) === parseInt(state.orderInfo[i].alarmid)) {
          state.orderInfo[i] = info
          flag = true
        }
      }
      if (!flag) {
        state.orderInfo.unshift(info)
      }
    },
    // mqtt处理订单（删除）
    set_del_order (state, id) {
      for (let i = 0; i < state.orderInfo.length; i++) {
        if (id === state.orderInfo[i].alarmid) {
          state.orderInfo.remove(state.orderInfo[i])
        }
      }
      // console.log(55, state.orderInfo)
    }
  },
  actions: {
    update_company_handle ({commit}, handle) {
      commit('set_company_handle', handle)
    },
    update_del_company_handle ({commit}, alarmId) {
      commit('set_del_companyHandle', alarmId)
    },
    update_order_info ({commit}, handle) {
      commit('set_order_info', handle)
    },
    update_del_order ({commit}, alarmId) {
      commit('set_del_order', alarmId)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/company.js